export const productsData = {
  4550723228770: {
    code: '4550723228770',
    name: '男撥水加工聚酯纖維塔夫綢外套',
    description: '',
    price: '2,190',
    alt: '黑色',
    hasImg: true,
  },
  4550723228817: {
    code: '4550723228817',
    name: '男撥水加工聚酯纖維塔夫綢外套',
    description: '',
    price: '2,190',
    alt: '米色',
    hasImg: true,
  },
  4550723228930: {
    code: '4550723228930',
    name: '男撥水加工聚酯纖維塔夫綢折領大衣',
    description: '',
    price: '3,990',
    alt: '黑色',
    hasImg: true,
  },
  4550723228978: {
    code: '4550723228978',
    name: '男撥水加工聚酯纖維塔夫綢折領大衣',
    description: '',
    price: '3,990',
    alt: '深藍',
    hasImg: true,
  },
  4550723229777: {
    code: '4550723229777',
    name: '男撥水加工連帽羽絨外套',
    description: '',
    price: '7,590',
    alt: '黑色',
    hasImg: true,
  },
  4550723229814: {
    code: '4550723229814',
    name: '男撥水加工連帽羽絨外套',
    description: '',
    price: '7,590',
    alt: '深棕',
    hasImg: true,
  },
  4550723230858: {
    code: '4550723230858',
    name: '男撥水加工聚酯纖維塔夫綢舒適長褲',
    description: '',
    price: '1,990',
    alt: '黑色',
    hasImg: true,
  },
  4550723230896: {
    code: '4550723230896',
    name: '男撥水加工聚酯纖維塔夫綢舒適長褲',
    description: '',
    price: '1,990',
    alt: '米色',
    hasImg: true,
  },
  4550723230933: {
    code: '4550723230933',
    name: '男撥水加工聚酯纖維塔夫綢舒適長褲',
    description: '',
    price: '1,990',
    alt: '深藍',
    hasImg: true,
  },
  4550723517089: {
    code: '4550723517089',
    name: '男皮革中筒休閒鞋',
    description: '',
    price: '3,990',
    alt: '黑色',
    hasImg: false,
  },
  4550723517140: {
    code: '4550723517140',
    name: '男皮革中筒休閒鞋',
    description: '',
    price: '3,990',
    alt: '棕色',
    hasImg: false,
  },
  4550723233538: {
    code: '4550723233538',
    name: '男銅氨纖維混開領長袖襯衫',
    description: '',
    price: '2,190',
    alt: '黑色',
    hasImg: true,
  },
  4550723233576: {
    code: '4550723233576',
    name: '男銅氨纖維混開領長袖襯衫',
    description: '',
    price: '2,190',
    alt: '暗藍',
    hasImg: true,
  },
  4550723230575: {
    code: '4550723230575',
    name: '男銅氨纖維混舒適錐形褲',
    description: '',
    price: '1,990',
    alt: '黑色',
    hasImg: true,
  },
  4550723230612: {
    code: '4550723230612',
    name: '男銅氨纖維混舒適錐形褲',
    description: '',
    price: '1,990',
    alt: '暗藍',
    hasImg: true,
  },
  4550723231336: {
    code: '4550723231336',
    name: '男棉混氂牛毛日式寬褲',
    description: '',
    price: '2,190',
    alt: '黑色',
    hasImg: true,
  },
  4550723233293: {
    code: '4550723233293',
    name: '男府綢標準領長袖襯衫',
    description: '',
    price: '1,990',
    alt: '棕格紋',
    hasImg: true,
  },
  4550723233330: {
    code: '4550723233330',
    name: '男府綢標準領長袖襯衫',
    description: '',
    price: '1,990',
    alt: '象牙白直紋',
    hasImg: true,
  },
  4550723233378: {
    code: '4550723233378',
    name: '男府綢標準領長袖襯衫',
    description: '',
    price: '1,990',
    alt: '淺粉直紋',
    hasImg: true,
  },
  4550723233415: {
    code: '4550723233415',
    name: '男府綢標準領長袖襯衫',
    description: '',
    price: '1,990',
    alt: '淺綠直紋',
    hasImg: true,
  },
  4550723226998: {
    code: '4550723226998',
    name: '男傳統紡紗機編織節紗長袖襯衫',
    description: '',
    price: '2,990',
    alt: '黑色',
    hasImg: true,
  },
  4550723227032: {
    code: '4550723227032',
    name: '男傳統紡紗機編織節紗長袖襯衫',
    description: '',
    price: '2,990',
    alt: '藍格紋',
    hasImg: true,
  },
  4550723152310: {
    code: '4550723152310',
    name: '男和歌山編織天竺圓領長袖T恤',
    description: '',
    price: '1,590',
    alt: '黑色',
    hasImg: true,
  },
  4550723152358: {
    code: '4550723152358',
    name: '男和歌山編織天竺圓領長袖T恤',
    description: '',
    price: '1,590',
    alt: '棕色',
    hasImg: true,
  },
  4550723231510: {
    code: '4550723231510',
    name: '男再生棉混長褲',
    description: '',
    price: '2,190',
    alt: '柔白',
    hasImg: true,
  },
  4550723231572: {
    code: '4550723231572',
    name: '男再生棉混長褲',
    description: '',
    price: '2,190',
    alt: '黑色',
    hasImg: true,
  },
  4550723226837: {
    code: '4550723226837',
    name: '男銅氨纖維混開領短袖襯衫',
    description: '',
    price: '1,990',
    alt: '黑色',
    hasImg: true,
  },
  4550723226875: {
    code: '4550723226875',
    name: '男銅氨纖維混開領短袖襯衫',
    description: '',
    price: '1,990',
    alt: '粉紅',
    hasImg: true,
  },
  4550723151153: {
    code: '4550723151153',
    name: '男傳統編織裏毛套衫',
    description: '',
    price: '1,790',
    alt: '黑色',
    hasImg: true,
  },
  4550723151191: {
    code: '4550723151191',
    name: '男傳統編織裏毛套衫',
    description: '',
    price: '1,790',
    alt: '粉米',
    hasImg: true,
  },
  4550723151238: {
    code: '4550723151238',
    name: '男傳統編織裏毛套衫',
    description: '',
    price: '1,790',
    alt: '棕色',
    hasImg: true,
  },
  4550723149792: {
    code: '4550723149792',
    name: '男和歌山編織天竺圓領短袖T恤',
    description: '',
    price: '1,390',
    alt: '白色',
    hasImg: true,
  },
  4550723149839: {
    code: '4550723149839',
    name: '男和歌山編織天竺圓領短袖T恤',
    description: '',
    price: '1,390',
    alt: '黑色',
    hasImg: true,
  },
  4550723149877: {
    code: '4550723149877',
    name: '男和歌山編織天竺圓領短袖T恤',
    description: '',
    price: '1,390',
    alt: '米黃',
    hasImg: true,
  },
  4550723149914: {
    code: '4550723149914',
    name: '男和歌山編織天竺圓領短袖T恤',
    description: '',
    price: '1,390',
    alt: '棕色',
    hasImg: true,
  },
  4550723150910: {
    code: '4550723150910',
    name: '男傳統紡紗機編織節紗短領長袖T恤',
    description: '',
    price: '1,390',
    alt: '柔白',
    hasImg: true,
  },
  4550723150958: {
    code: '4550723150958',
    name: '男傳統紡紗機編織節紗短領長袖T恤',
    description: '',
    price: '1,390',
    alt: '煙燻藍',
    hasImg: true,
  },
  4550723150996: {
    code: '4550723150996',
    name: '男傳統紡紗機編織節紗短領長袖T恤',
    description: '',
    price: '1,390',
    alt: '暗藍',
    hasImg: true,
  },
  4550723227155: {
    code: '4550723227155',
    name: '男傳統紡紗機編織節紗套衫',
    description: '',
    price: '2,990',
    alt: '黑格紋',
    hasImg: true,
  },
  4550723227193: {
    code: '4550723227193',
    name: '男傳統紡紗機編織節紗套衫',
    description: '',
    price: '2,990',
    alt: '暗藍格紋',
    hasImg: true,
  },
  4550723229920: {
    code: '4550723229920',
    name: '女撥水加工聚酯纖維塔夫綢外套',
    description: '',
    price: '2,190',
    alt: '黑色',
    hasImg: true,
  },
  4550723229968: {
    code: '4550723229968',
    name: '女撥水加工聚酯纖維塔夫綢外套',
    description: '',
    price: '2,190',
    alt: '深棕',
    hasImg: true,
  },
  4550723150460: {
    code: '4550723150460',
    name: '女亞麻混短袖T恤',
    description: '',
    price: '990',
    alt: '柔白',
    hasImg: true,
  },
  4550723150507: {
    code: '4550723150507',
    name: '女亞麻混短袖T恤',
    description: '',
    price: '990',
    alt: '黑色',
    hasImg: true,
  },
  4550723150545: {
    code: '4550723150545',
    name: '女亞麻混短袖T恤',
    description: '',
    price: '990',
    alt: '粉紅',
    hasImg: true,
  },
  4550723150583: {
    code: '4550723150583',
    name: '女亞麻混短袖T恤',
    description: '',
    price: '990',
    alt: '深藍',
    hasImg: true,
  },
  4550723232647: {
    code: '4550723232647',
    name: '女撥水加工聚酯纖維塔夫綢打褶舒適裙',
    description: '',
    price: '1,990',
    alt: '黑色',
    hasImg: true,
  },
  4550723232685: {
    code: '4550723232685',
    name: '女撥水加工聚酯纖維塔夫綢打褶舒適裙',
    description: '',
    price: '1,990',
    alt: '深藍',
    hasImg: true,
  },
  4550723232722: {
    code: '4550723232722',
    name: '女撥水加工聚酯纖維塔夫綢打褶舒適裙',
    description: '',
    price: '1,990',
    alt: '深棕',
    hasImg: true,
  },
  4550723517195: {
    code: '4550723517195',
    name: '女皮革中筒休閒鞋',
    description: '',
    price: '3,990',
    alt: '黑色',
    hasImg: false,
  },
  4550723517249: {
    code: '4550723517249',
    name: '女皮革中筒休閒鞋',
    description: '',
    price: '3,990',
    alt: '棕色',
    hasImg: false,
  },
  4550723228022: {
    code: '4550723228022',
    name: '女銅氨纖維混無袖洋裝',
    description: '',
    price: '2,190',
    alt: '黑色',
    hasImg: true,
  },
  4550723228060: {
    code: '4550723228060',
    name: '女銅氨纖維混無袖洋裝',
    description: '',
    price: '2,190',
    alt: '暗藍',
    hasImg: true,
  },
  4550723151863: {
    code: '4550723151863',
    name: '女萊賽爾天竺長袖T恤',
    description: '',
    price: '1,390',
    alt: '柔白',
    hasImg: true,
  },
  4550723151900: {
    code: '4550723151900',
    name: '女萊賽爾天竺長袖T恤',
    description: '',
    price: '1,390',
    alt: '黑色',
    hasImg: true,
  },
  4550723151948: {
    code: '4550723151948',
    name: '女萊賽爾天竺長袖T恤',
    description: '',
    price: '1,390',
    alt: '棕色',
    hasImg: true,
  },

  4550723232258: {
    code: '4550723232258',
    name: '女棉混氂牛毛日式寬褲',
    description: '',
    price: '2,190',
    alt: '黑色',
    hasImg: false,
  },
  4550723150064: {
    code: '4550723150064',
    name: '女亞麻混坦克背心',
    description: '',
    price: '790',
    alt: '柔白',
    hasImg: true,
  },
  4550723150101: {
    code: '4550723150101',
    name: '女亞麻混坦克背心',
    description: '',
    price: '790',
    alt: '黑色',
    hasImg: true,
  },
  4550723150149: {
    code: '4550723150149',
    name: '女亞麻混坦克背心',
    description: '',
    price: '790',
    alt: '深藍',
    hasImg: true,
  },
  4550723227346: {
    code: '4550723227346',
    name: '女府綢立領長袖襯衫',
    description: '',
    price: '1,790',
    alt: '柔白',
    hasImg: true,
  },
  4550723227384: {
    code: '4550723227384',
    name: '女府綢立領長袖襯衫',
    description: '',
    price: '1,790',
    alt: '象牙白直紋',
    hasImg: true,
  },
  4550723227421: {
    code: '4550723227421',
    name: '女府綢立領長袖襯衫',
    description: '',
    price: '1,790',
    alt: '粉紅直紋',
    hasImg: true,
  },
  4550723168656: {
    code: '4550723168656',
    name: '女駱馬毛高密織亨利領針織衫',
    description: '',
    price: '1,990',
    alt: '柔白',
    hasImg: true,
  },
  4550723168694: {
    code: '4550723168694',
    name: '女駱馬毛高密織亨利領針織衫',
    description: '',
    price: '1,990',
    alt: '淺黃',
    hasImg: true,
  },
  4550723168731: {
    code: '4550723168731',
    name: '女駱馬毛高密織亨利領針織衫',
    description: '',
    price: '1,990',
    alt: '深棕',
    hasImg: true,
  },
  4550723154895: {
    code: '4550723154895',
    name: '女蠶絲羅紋長袖T恤',
    description: '',
    price: '1,390',
    alt: '深灰',
    hasImg: true,
  },
  4550723154918: {
    code: '4550723154918',
    name: '女蠶絲羅紋長袖T恤',
    description: '',
    price: '1,390',
    alt: '黑色',
    hasImg: true,
  },
  4550723154932: {
    code: '4550723154932',
    name: '女蠶絲羅紋長袖T恤',
    description: '',
    price: '1,390',
    alt: '象牙白',
    hasImg: true,
  },
  4550723232425: {
    code: '4550723232425',
    name: '女再生棉混繭型褲',
    description: '',
    price: '2,190',
    alt: '柔白',
    hasImg: false,
  },
  4550723232487: {
    code: '4550723232487',
    name: '女再生棉混繭型褲',
    description: '',
    price: '2,190',
    alt: '暗藍',
    hasImg: false,
  },
  4550723228404: {
    code: '4550723228404',
    name: '女棉內起毛短版長袖襯衫',
    description: '',
    price: '1,990',
    alt: '灰色',
    hasImg: false,
  },
  4550723228442: {
    code: '4550723228442',
    name: '女棉內起毛短版長袖襯衫',
    description: '',
    price: '1,990',
    alt: '黑色',
    hasImg: false,
  },
  4550723228480: {
    code: '4550723228480',
    name: '女棉內起毛短版長袖襯衫',
    description: '',
    price: '1,990',
    alt: '暗藍格紋',
    hasImg: false,
  },
  4550723154048: {
    code: '4550723154048',
    name: '女棉混喀什米爾圓領T恤',
    description: '',
    price: '990',
    alt: '柔白',
    hasImg: false,
  },
  4550723154086: {
    code: '4550723154086',
    name: '女棉混喀什米爾圓領T恤',
    description: '',
    price: '990',
    alt: '灰色',
    hasImg: false,
  },
  4550723154123: {
    code: '4550723154123',
    name: '女棉混喀什米爾圓領T恤',
    description: '',
    price: '990',
    alt: '灰白',
    hasImg: false,
  },
  4550723154161: {
    code: '4550723154161',
    name: '女棉混喀什米爾圓領T恤',
    description: '',
    price: '990',
    alt: '黑色',
    hasImg: false,
  },
  4550723231923: {
    code: '4550723231923',
    name: '女銅氨纖維混圍裹裙',
    description: '',
    price: '1,990',
    alt: '黑色',
    hasImg: true,
  },
  4550723231961: {
    code: '4550723231961',
    name: '女銅氨纖維混圍裹裙',
    description: '',
    price: '1,990',
    alt: '暗藍',
    hasImg: true,
  },
  4550723155328: {
    code: '4550723155328',
    name: '女棉混喀什米爾高領無袖T恤',
    description: '',
    price: '990',
    alt: '柔白',
    hasImg: false,
  },
  4550723155366: {
    code: '4550723155366',
    name: '女棉混喀什米爾高領無袖T恤',
    description: '',
    price: '990',
    alt: '灰白',
    hasImg: false,
  },
  4550723155403: {
    code: '4550723155403',
    name: '女棉混喀什米爾高領無袖T恤',
    description: '',
    price: '990',
    alt: '黑色',
    hasImg: false,
  },
  4550723232135: {
    code: '4550723232135',
    name: '女棉混氂牛毛打褶寬版褲',
    description: '',
    price: '1,990',
    alt: '黑色',
    hasImg: false,
  },
  4550723232173: {
    code: '4550723232173',
    name: '女棉混氂牛毛打褶寬版褲',
    description: '',
    price: '1,990',
    alt: '暗藍',
    hasImg: false,
  },
  4550723232210: {
    code: '4550723232210',
    name: '女棉混氂牛毛打褶寬版褲',
    description: '',
    price: '1,990',
    alt: '深棕',
    hasImg: false,
  },
  4550723168854: {
    code: '4550723168854',
    name: '女駱馬毛高密織披肩式罩衫',
    description: '',
    price: '2,190',
    alt: '柔白',
    hasImg: true,
  },
  4550723168892: {
    code: '4550723168892',
    name: '女駱馬毛高密織披肩式罩衫',
    description: '',
    price: '2,190',
    alt: '黑色',
    hasImg: true,
  },
  4550723155076: {
    code: '4550723155076',
    name: '女蠶絲羅紋坦克背心',
    description: '',
    price: '990',
    alt: '深灰',
    hasImg: true,
  },
  4550723155090: {
    code: '4550723155090',
    name: '女蠶絲羅紋坦克背心',
    description: '',
    price: '990',
    alt: '黑色',
    hasImg: true,
  },
  4550723155113: {
    code: '4550723155113',
    name: '女蠶絲羅紋坦克背心',
    description: '',
    price: '990',
    alt: '象牙白',
    hasImg: true,
  },
  4550723227827: {
    code: '4550723227827',
    name: '女銅氨纖維混七分袖襯衫',
    description: '',
    price: '2,190',
    alt: '黑色',
    hasImg: true,
  },
  4550723227865: {
    code: '4550723227865',
    name: '女銅氨纖維混七分袖襯衫',
    description: '',
    price: '2,190',
    alt: '粉紅',
    hasImg: true,
  },
  4550723227902: {
    code: '4550723227902',
    name: '女銅氨纖維混七分袖襯衫',
    description: '',
    price: '2,190',
    alt: '暗藍',
    hasImg: true,
  },
  4550723228206: {
    code: '4550723228206',
    name: '女棉緞布抓皺洋裝',
    description: '',
    price: '1,990',
    alt: '暗藍',
    hasImg: true,
  },
  4550723228244: {
    code: '4550723228244',
    name: '女棉緞布抓皺洋裝',
    description: '',
    price: '1,990',
    alt: '棕色',
    hasImg: true,
  },
  4550723227582: {
    code: '4550723227582',
    name: '女棉緞布抓皺套衫',
    description: '',
    price: '1,390',
    alt: '柔白',
    hasImg: true,
  },
  4550723227629: {
    code: '4550723227629',
    name: '女棉緞布抓皺套衫',
    description: '',
    price: '1,390',
    alt: '柔白',
    hasImg: true,
  },
  4550723227667: {
    code: '4550723227667',
    name: '女棉緞布抓皺套衫',
    description: '',
    price: '1,390',
    alt: '柔白',
    hasImg: true,
  },
  4550723153157: {
    code: '4550723153157',
    name: '女棉天竺寬鬆長袖T恤',
    description: '',
    price: '990',
    alt: '柔白',
    hasImg: true,
  },
  4550723153195: {
    code: '4550723153195',
    name: '女棉天竺寬鬆長袖T恤',
    description: '',
    price: '990',
    alt: '深灰',
    hasImg: true,
  },
  4550723153232: {
    code: '4550723153232',
    name: '女棉天竺寬鬆長袖T恤',
    description: '',
    price: '990',
    alt: '黑色',
    hasImg: true,
  },
  4550723151627: {
    code: '4550723151627',
    name: '女萊賽爾天竺五分袖T恤',
    description: '',
    price: '990',
    alt: '柔白',
    hasImg: true,
  },
  4550723151665: {
    code: '4550723151665',
    name: '女萊賽爾天竺五分袖T恤',
    description: '',
    price: '990',
    alt: '黑色',
    hasImg: true,
  },
  4550723151702: {
    code: '4550723151702',
    name: '女萊賽爾天竺五分袖T恤',
    description: '',
    price: '990',
    alt: '棕色',
    hasImg: true,
  },
  4550723153355: {
    code: '4550723153355',
    name: '女棉天竺寬鬆舒適長褲',
    description: '',
    price: '990',
    alt: '深灰',
    hasImg: true,
  },
  4550723153393: {
    code: '4550723153393',
    name: '女棉天竺寬鬆舒適長褲',
    description: '',
    price: '990',
    alt: '黑色',
    hasImg: true,
  },
  4550723152556: {
    code: '4550723152556',
    name: '柔滑針織長袖套衫',
    description: '',
    price: '990',
    alt: '柔白',
    hasImg: true,
  },
  4550723152600: {
    code: '4550723152600',
    name: '柔滑針織長袖套衫',
    description: '',
    price: '990',
    alt: '深灰',
    hasImg: true,
  },
  4550723152655: {
    code: '4550723152655',
    name: '柔滑針織長袖套衫',
    description: '',
    price: '990',
    alt: '黑色',
    hasImg: true,
  },
  4550723179881: {
    code: '4550723179881',
    name: '柔滑針織長袖套衫',
    description: '',
    price: '990',
    alt: '暗藍',
    hasImg: true,
  },
  4550723516488: {
    code: '4550723516488',
    name: '男日本編織羊毛混粗織直角襪',
    description: '',
    price: '590',
    alt: '墨灰',
    hasImg: true,
  },
  4550723516501: {
    code: '4550723516501',
    name: '男日本編織羊毛混粗織直角襪',
    description: '',
    price: '590',
    alt: '象牙白',
    hasImg: true,
  },
  4550723516525: {
    code: '4550723516525',
    name: '男日本編織羊毛混粗織直角襪',
    description: '',
    price: '590',
    alt: '駝色',
    hasImg: true,
  },
  4550723516549: {
    code: '4550723516549',
    name: '男日本編織羊毛混粗織直角襪',
    description: '',
    price: '590',
    alt: '摩卡棕',
    hasImg: true,
  },
  4550723516563: {
    code: '4550723516563',
    name: '男日本編織羊毛混粗織直角襪',
    description: '',
    price: '590',
    alt: '混黑色',
    hasImg: true,
  },
  4550723608176: {
    code: '4550723608176',
    name: '男日本編織羊毛混粗織直角襪',
    description: '',
    price: '590',
    alt: '深棕',
    hasImg: true,
  },

  4550723516570: {
    code: '4550723516570',
    name: '女日本編織羊毛混粗織直角襪',
    description: '',
    price: '590',
    alt: '墨灰',
    hasImg: true,
  },
  4550723516587: {
    code: '4550723516587',
    name: '女日本編織羊毛混粗織直角襪',
    description: '',
    price: '590',
    alt: '象牙白',
    hasImg: true,
  },
  4550723516594: {
    code: '4550723516594',
    name: '女日本編織羊毛混粗織直角襪',
    description: '',
    price: '590',
    alt: '駝色',
    hasImg: true,
  },
  4550723516600: {
    code: '4550723516600',
    name: '女日本編織羊毛混粗織直角襪',
    description: '',
    price: '590',
    alt: '摩卡棕',
    hasImg: true,
  },
  4550723516617: {
    code: '4550723516617',
    name: '女日本編織羊毛混粗織直角襪',
    description: '',
    price: '590',
    alt: '混黑色',
    hasImg: true,
  },
  4550723608183: {
    code: '4550723608183',
    name: '女日本編織羊毛混粗織直角襪',
    description: '',
    price: '590',
    alt: '深棕',
    hasImg: true,
  },
  4550723711616: {
    code: '4550723711616',
    name: '鋁合金60L拉桿箱',
    description: '',
    price: '19,000',
    alt: '黑色',
    hasImg: true,
  },
  4550723711630: {
    code: '4550723711630',
    name: '鋁合金60L拉桿箱',
    description: '',
    price: '19,000',
    alt: '銀色',
    hasImg: true,
  },
  4550723711623: {
    code: '4550723711623',
    name: '鋁合金34L拉桿箱',
    description: '',
    price: '15,000',
    alt: '黑色',
    hasImg: true,
  },
  4550723711647: {
    code: '4550723711647',
    name: '鋁合金34L拉桿箱',
    description: '',
    price: '15,000',
    alt: '銀色',
    hasImg: true,
  },
  4550723516624: {
    code: '4550723516624',
    name: '再生尼龍迷你波士頓包',
    description: '',
    price: '1,390',
    alt: '黑色',
    hasImg: true,
  },
  4550723516631: {
    code: '4550723516631',
    name: '再生尼龍迷你波士頓包',
    description: '',
    price: '1,390',
    alt: '深棕',
    hasImg: true,
  },
  4550723516648: {
    code: '4550723516648',
    name: '橄欖萃取革無孔皮帶',
    description: '',
    price: '1,190',
    alt: '黑色',
    hasImg: false,
  },
  4550723516655: {
    code: '4550723516655',
    name: '橄欖萃取革無孔皮帶',
    description: '',
    price: '1,190',
    alt: '深棕',
    hasImg: false,
  },
  4550723516983: {
    code: '4550723516983',
    name: '再生尼龍迷你水桶包',
    description: '',
    price: '1,390',
    alt: '黑色',
    hasImg: true,
  },
  4550723516990: {
    code: '4550723516990',
    name: '再生尼龍迷你水桶包',
    description: '',
    price: '1,390',
    alt: '深棕',
    hasImg: true,
  },
  4550723517003: {
    code: '4550723517003',
    name: '再生尼龍水桶包',
    description: '',
    price: '1,790',
    alt: '黑色',
    hasImg: true,
  },
  4550723517010: {
    code: '4550723517010',
    name: '再生尼龍水桶包',
    description: '',
    price: '1,790',
    alt: '深棕',
    hasImg: true,
  },
  4550723517027: {
    code: '4550723517027',
    name: '皮革迷你肩背包',
    description: '',
    price: '2,990',
    alt: '黑色',
    hasImg: true,
  },
  4550723517034: {
    code: '4550723517034',
    name: '皮革肩背包',
    description: '',
    price: '3,590',
    alt: '黑色',
    hasImg: true,
  },
  4550723239592: {
    code: '4550723239592',
    name: '喀什米爾披肩',
    description: '',
    price: '2,990',
    alt: '黑色',
    hasImg: true,
  },
  4550723239608: {
    code: '4550723239608',
    name: '喀什米爾披肩',
    description: '',
    price: '2,990',
    alt: '淺粉',
    hasImg: true,
  },
  4550723239622: {
    code: '4550723239622',
    name: '喀什米爾披肩',
    description: '',
    price: '2,990',
    alt: '混灰',
    hasImg: true,
  },
  4550723235228: {
    code: '4550723235228',
    name: '喀什米爾混針織帽',
    description: '',
    price: '1,390',
    alt: '淺灰',
    hasImg: true,
  },
  4550723235235: {
    code: '4550723235235',
    name: '喀什米爾混針織帽',
    description: '',
    price: '1,390',
    alt: '深灰',
    hasImg: true,
  },
  4550723235242: {
    code: '4550723235242',
    name: '喀什米爾混針織帽',
    description: '',
    price: '1,390',
    alt: '煙燻藍',
    hasImg: true,
  },
  4550723235273: {
    code: '4550723235273',
    name: '喀什米爾混針織貝雷帽',
    description: '',
    price: '1,390',
    alt: '淺灰',
    hasImg: true,
  },
  4550723235280: {
    code: '4550723235280',
    name: '喀什米爾混針織貝雷帽',
    description: '',
    price: '1,390',
    alt: '深灰',
    hasImg: true,
  },
  4550723235297: {
    code: '4550723235297',
    name: '喀什米爾混針織貝雷帽',
    description: '',
    price: '1,390',
    alt: '煙燻藍',
    hasImg: true,
  },
  4550723153607: {
    code: '4550723153607',
    name: '柔滑針織舒適長褲',
    description: '',
    price: '1,390',
    alt: '深灰',
    hasImg: true,
  },
  4550723153652: {
    code: '4550723153652',
    name: '柔滑針織舒適長褲',
    description: '',
    price: '1,390',
    alt: '黑色',
    hasImg: true,
  },
  4550723180030: {
    code: '4550723180030',
    name: '柔滑針織舒適長褲',
    description: '',
    price: '1,390',
    alt: '暗藍',
    hasImg: true,
  },
};

export const lookData = [
  {
    id: 1,
    layout: '02',
    headingAlign: 'left',
    images: ['01-look-01', '01-look-02', '01-look-03'],
    productLists: [
      {
        id: 1,
        products: [
          {
            id: 1,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723228770', '4550723228817'],
          },
          {
            id: 2,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4550723152556', '4550723152600', '4550723152655', '4550723179881'],
          },
          {
            id: 3,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723230858', '4550723230896', '4550723230933'],
          },
          {
            id: 4,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723517089', '4550723517140'],
          },
        ],
      },
      {
        id: 2,
        products: [
          {
            id: 1,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723229920', '4550723229968'],
          },
          {
            id: 2,
            current_index: 3,
            no_chips: false,
            tag: '',
            items: ['4550723150460', '4550723150507', '4550723150545', '4550723150583'],
          },
          {
            id: 3,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4550723232647', '4550723232685', '4550723232722'],
          },
          {
            id: 4,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723517195', '4550723517249'],
          },
        ],
      },
    ],
    tips: '模特兒身高：185cm／外套XL號、長褲XL號、運動鞋28.0cm<br />模特兒身高：175cm／外套L號、長版上衣L號、長褲L號、運動鞋25.0cm',
  },
  {
    id: 2,
    layout: '07',
    headingAlign: 'right',
    images: ['02-look-01', '02-look-02', '02-look-03'],
    productLists: [
      {
        id: 1,
        products: [
          {
            id: 1,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4550723233538', '4550723233576'],
          },
          {
            id: 2,
            current_index: 3,
            no_chips: false,
            tag: '',
            items: ['4550723152556', '4550723152600', '4550723152655', '4550723179881'],
          },
          {
            id: 3,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4550723230575', '4550723230612'],
          },
        ],
      },
      {
        id: 2,
        products: [
          {
            id: 1,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4550723228022', '4550723228060'],
          },
          {
            id: 2,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4550723151863', '4550723151900', '4550723151948'],
          },
          {
            id: 3,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723517195', '4550723517249'],
          },
        ],
      },
    ],
    tips: '模特兒身高：185cm／針織衫L號、長褲XL號<br />模特兒身高：175cm／針織衫L號、長褲L號',
  },
  {
    id: 3,
    layout: '02',
    headingAlign: 'left',
    images: ['03-look-01', '03-look-02', '03-look-03'],
    productLists: [
      {
        id: 1,
        products: [
          {
            id: 1,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723231336'],
          },
          {
            id: 2,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4550723233293', '4550723233330', '4550723233378', '4550723233415'],
          },
          {
            id: 3,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723516648', '4550723516655'],
          },
        ],
      },
      {
        id: 1,
        products: [
          {
            id: 1,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723232258'],
          },
          {
            id: 2,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723150064', '4550723150101', '4550723150149'],
          },
          {
            id: 3,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723227346', '4550723227384', '4550723227421'],
          },
          {
            id: 4,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723517195', '4550723517249'],
          },
        ],
      },
    ],
    tips: '模特兒身高：185cm／襯衫XL號、長褲XL號、運動鞋28.0cm<br />模特兒身高：175cm／襯衫L號、長褲70腰圍、運動鞋25.0cm',
  },
  {
    id: 4,
    layout: '04',
    headingAlign: 'right',
    images: ['04-look-01', '04-look-02'],
    productLists: [
      {
        id: 1,
        products: [
          {
            id: 1,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4550723226998', '4550723227032'],
          },
          {
            id: 2,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723152310', '4550723152358'],
          },
          {
            id: 3,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4550723231510', '4550723231572'],
          },
          {
            id: 4,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723516648', '4550723516655'],
          },
        ],
      },
    ],
    tips: '模特兒身高：185cm／外套XL號、襯衫XL號、長褲XL號、運動鞋28.0cm',
  },
  {
    id: 5,
    layout: '03',
    headingAlign: 'left',
    images: ['05-look-01', '05-look-02'],
    productLists: [
      {
        id: 1,
        products: [
          {
            id: 1,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723168656', '4550723168694', '4550723168731'],
          },
          {
            id: 2,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723154895', '4550723154918', '4550723154932'],
          },
          {
            id: 3,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4550723232425', '4550723232487'],
          },
          {
            id: 4,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4550723516648', '4550723516655'],
          },
        ],
      },
    ],
    tips: '模特兒身高：185cm／外套XL號',
  },
  {
    id: 6,
    layout: '07',
    headingAlign: 'right',
    images: ['06-look-01', '06-look-02', '06-look-03'],
    productLists: [
      {
        id: 1,
        products: [
          {
            id: 1,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723228404', '4550723228442', '4550723228480'],
          },
          {
            id: 2,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4550723154048', '4550723154086', '4550723154123', '4550723154161'],
          },
          {
            id: 3,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723231923', '4550723231961'],
          },
        ],
      },
      {
        id: 2,
        products: [
          {
            id: 1,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723226837', '4550723226875'],
          },
          {
            id: 2,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4550723153607', '4550723153652', '4550723180030'],
          },
        ],
      },
    ],
    tips: '模特兒身高：175cm／大衣L號、外套L號、長褲L號、T 恤L號、運動鞋25.0cm',
  },
  {
    id: 7,
    layout: '03',
    headingAlign: 'left',
    images: ['07-look-01', '07-look-02'],
    productLists: [
      {
        id: 1,
        products: [
          {
            id: 1,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4550723151153', '4550723151191', '4550723151238'],
          },
          {
            id: 2,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723149792', '4550723149839', '4550723149877', '4550723149914'],
          },
          {
            id: 3,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723231510', '4550723231572'],
          },
          {
            id: 4,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4550723516648', '4550723516655'],
          },
        ],
      },
    ],
    tips: '※未刊載之商品為示意搭配商品，或為日後預計販售之商品。',
  },
  {
    id: 8,
    layout: '04',
    headingAlign: 'right',
    images: ['08-look-01', '08-look-02'],
    productLists: [
      {
        id: 1,
        products: [
          {
            id: 1,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4550723168854', '4550723168892'],
          },
          {
            id: 2,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4550723155076', '4550723155090', '4550723155113'],
          },
          {
            id: 3,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4550723232425', '4550723232487'],
          },
          {
            id: 4,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723516648', '4550723516655'],
          },
          {
            id: 5,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723517195', '4550723517249'],
          },
        ],
      },
    ],
    tips: '※未刊載之商品為示意搭配商品，或為日後預計販售之商品。',
  },
  {
    id: 9,
    layout: '03',
    headingAlign: 'left',
    images: ['09-look-01', '09-look-02'],
    productLists: [
      {
        id: 1,
        products: [
          {
            id: 1,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4550723155328', '4550723155366', '4550723155403'],
          },
          {
            id: 2,
            current_index: 2,
            no_chips: false,
            tag: '',
            items: ['4550723154048', '4550723154086', '4550723154123', '4550723154161'],
          },
          {
            id: 3,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723232135', '4550723232173', '4550723232210'],
          },
          {
            id: 4,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723516648', '4550723516655'],
          },
          {
            id: 5,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723517195', '4550723517249'],
          },
        ],
      },
    ],
    tips: '※未刊載之商品為示意搭配商品，或為日後預計販售之商品。',
  },
];

export const pickupData = [
  {
    id: 1,
    title: '傳統紡紗機編織節紗(長袖襯衫)',
    img: 'pickup-1-hero',
    description:
      '使用經整修與改造的 50 年前精紡機，紡製出接近昔日品質的竹節紗。因紡紗過程施力較少，得以保留棉花原有的風合與自然不規則的紋理。<br /><br />採用比一般 T 恤約粗 2 倍的紗線，打造出紮實厚實的布料質感。天然且不規則的竹節紋理是其特色，隨著穿著次數增加，布料風合會更加豐富，逐漸貼合身形。',
    products: [
      {
        id: 1,
        current_index: 0,
        no_chips: false,
        tag: '',
        items: ['4550723150910', '4550723150958', '4550723150996'],
      },
      {
        id: 2,
        current_index: 0,
        no_chips: false,
        tag: '',
        items: ['4550723226998', '4550723227032'],
      },
      {
        id: 3,
        current_index: 0,
        no_chips: false,
        tag: '',
        items: ['4550723227155', '4550723227193'],
      },
    ],
  },
  {
    id: 2,
    title: '銅氨纖維混',
    img: 'pickup-2-hero',
    description:
      '銅氨纖維是以棉籽絨（Cotton Linter）為原料製成的再生纖維素纖維。透過賦予過去未被充分利用的原料新價值而製成，也廣泛運用於西裝內裡等面料。<br /><br />藉由極細微的導濕通道，快速吸收並釋放濕氣，有助於調節衣物內的濕度，減少悶熱與黏膩感。<br />此外，由於纖維內能含有較多水分，因此具有較高的熱傳導率，能迅速將肌膚表面的熱氣帶到衣物外部，具有良好的散熱效果。',
    products: [
      {
        id: 1,
        current_index: 0,
        no_chips: false,
        tag: '',
        items: ['4550723233538', '4550723233576'],
      },
      {
        id: 2,
        current_index: 0,
        no_chips: false,
        tag: '',
        items: ['4550723226837', '4550723226875'],
      },
      {
        id: 3,
        current_index: 1,
        no_chips: false,
        tag: '',
        items: ['4550723230575', '4550723230612'],
      },
      {
        id: 4,
        current_index: 0,
        no_chips: false,
        tag: '',
        items: ['4550723228022', '4550723228060'],
      },
      {
        id: 5,
        current_index: 0,
        no_chips: false,
        tag: '',
        items: ['4550723227827', '4550723227865', '4550723227902'],
      },
      {
        id: 6,
        current_index: 0,
        no_chips: false,
        tag: '',
        items: ['4550723231923', '4550723231961'],
      },
    ],
  },
  {
    id: 3,
    title: '撥水加工聚酯纖維(形狀記憶)',
    img: '',
    description:
      '聚酯纖維是一種可透過紗線、織造、針織及後加工等方式，賦予各種機能特性的素材。<br />經紗採用柔軟紗線，緯紗則高密度織入具彈簧般捲曲結構的形狀記憶紗線，兼具挺度與柔韌性。<br />即使產生摺痕，只需以手稍加撫平，便容易恢復原有形狀。此外，透過揉洗感皺褶加工處理，呈現自然的布料風合。<br />經撥水加工處理，可抵禦輕微雨水。',
    products: [
      {
        id: 1,
        current_index: 0,
        no_chips: false,
        tag: '',
        items: ['4550723228930', '4550723228978'],
      },
      {
        id: 2,
        current_index: 0,
        no_chips: false,
        tag: '',
        items: ['4550723228770', '4550723228817'],
      },
      {
        id: 3,
        current_index: 1,
        no_chips: false,
        tag: '',
        items: ['4550723230858', '4550723230896', '4550723230933'],
      },
      {
        id: 4,
        current_index: 0,
        no_chips: false,
        tag: '',
        items: ['4550723229920', '4550723229968'],
      },
      {
        id: 5,
        current_index: 1,
        no_chips: false,
        tag: '',
        items: ['4550723232647', '4550723232685', '4550723232722'],
      },
    ],
  },
];

export const lineupData = [
  {
    id: 1,
    heading: '男裝',
    productLists: [
      {
        title: '外套',
        products: [
          {
            id: 1,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723228930', '4550723228978'],
          },
          {
            id: 2,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4550723228770', '4550723228817'],
          },
        ],
      },
      {
        title: '襯衫',
        products: [
          {
            id: 1,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723233538', '4550723233576'],
          },
          {
            id: 2,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723233293', '4550723233330', '4550723233378', '4550723233415'],
          },
          {
            id: 3,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723226837', '4550723226875'],
          },
        ],
      },
      {
        title: '上衣',
        products: [
          {
            id: 1,
            current_index: 2,
            no_chips: false,
            tag: '',
            items: ['4550723151153', '4550723151191', '4550723151238'],
          },
          {
            id: 2,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723152556', '4550723152600', '4550723152655', '4550723179881'],
          },
          {
            id: 3,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723152310', '4550723152358'],
          },
          {
            id: 4,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723149792', '4550723149839', '4550723149877', '4550723149914'],
          },
        ],
      },
      {
        title: '褲子',
        products: [
          {
            id: 1,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723230575', '4550723230612'],
          },
          {
            id: 2,
            current_index: 2,
            no_chips: false,
            tag: '',
            items: ['4550723230858', '4550723230896', '4550723230933'],
          },
          {
            id: 3,
            current_index: 2,
            no_chips: false,
            tag: '',
            items: ['4550723153607', '4550723153652', '4550723180030'],
          },
        ],
      },
      {
        title: '鞋款',
        products: [
          {
            id: 1,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723517089', '4550723517140'],
          },
        ],
      },
    ],
  },
  {
    id: 2,
    heading: '女裝',
    productLists: [
      {
        title: '外套',
        products: [
          {
            id: 1,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723229920', '4550723229968'],
          },
        ],
      },
      {
        title: '洋裝・襯衫',
        products: [
          {
            id: 1,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723228206', '4550723228244'],
          },
          {
            id: 2,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4550723228022', '4550723228060'],
          },
          {
            id: 3,
            current_index: 2,
            no_chips: false,
            tag: '',
            items: ['4550723227582', '4550723227629', '4550723227667'],
          },
          {
            id: 4,
            current_index: 2,
            no_chips: false,
            tag: '',
            items: ['4550723227346', '4550723227384', '4550723227421'],
          },
          {
            id: 5,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4550723227827', '4550723227865', '4550723227902'],
          },
        ],
      },
      {
        title: '上衣',
        products: [
          {
            id: 1,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4550723168854', '4550723168892'],
          },
          {
            id: 2,
            current_index: 2,
            no_chips: false,
            tag: '',
            items: ['4550723152556', '4550723152600', '4550723152655', '4550723179881'],
          },
          {
            id: 3,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4550723168656', '4550723168694', '4550723168731'],
          },
          {
            id: 4,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4550723151863', '4550723151900', '4550723151948'],
          },
          {
            id: 5,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4550723153157', '4550723153195', '4550723153232'],
          },
          {
            id: 6,
            current_index: 2,
            no_chips: false,
            tag: '',
            items: ['4550723154895', '4550723154918', '4550723154932'],
          },
          {
            id: 7,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723151627', '4550723151665', '4550723151702'],
          },
          {
            id: 8,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4550723150460', '4550723150507', '4550723150545', '4550723150583'],
          },
          {
            id: 9,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4550723150064', '4550723150101', '4550723150149'],
          },
          {
            id: 10,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4550723155076', '4550723155090', '4550723155113'],
          },
        ],
      },
      {
        title: '褲子',
        products: [
          {
            id: 1,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723231923', '4550723231961'],
          },
          {
            id: 2,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4550723232647', '4550723232685', '4550723232722'],
          },
          {
            id: 3,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4550723153355', '4550723153393'],
          },
          {
            id: 4,
            current_index: 2,
            no_chips: false,
            tag: '',
            items: ['4550723153607', '4550723153652', '4550723180030'],
          },
        ],
      },
      {
        title: '鞋款',
        products: [
          {
            id: 1,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723517195', '4550723517249'],
          },
        ],
      },
    ],
  },
  {
    id: 3,
    heading: '服飾配件',
    productLists: [
      {
        title: '包包・旅行',
        products: [
          {
            id: 1,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4550723516624', '4550723516631'],
          },
          {
            id: 2,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723517003', '4550723517010'],
          },
          {
            id: 3,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4550723516983', '4550723516990'],
          },
          {
            id: 4,
            current_index: 1,
            no_chips: false,
            tag: '',
            items: ['4550723711623', '4550723711647'],
          },
          {
            id: 5,
            current_index: 0,
            no_chips: false,
            tag: '',
            items: ['4550723711616', '4550723711630'],
          },
        ],
      },
    ],
  },
];

export const featureData = {
  img: 'feature',
  heading1: '',
  heading2: '',
  title: '皮革低筒休閒鞋<br />（女鞋・男鞋）',
  description:
    '採用硫化工法製作的運動鞋。<br />鞋底為中空結構設計，兼具輕量感並能有效減緩行走時的衝擊。<br />為保護足部並維持穩定步伐，鞋頭與鞋跟部分設有鞋殼芯。<br />橡膠鞋帶設計，方便穿脫並提供舒適貼合的穿著感。',
  products: [
    {
      id: 1,
      current_index: 1,
      no_chips: false,
      tag: '',
      items: ['4547315579471', '4547315579532'],
    },
    {
      id: 2,
      current_index: 0,
      no_chips: false,
      tag: '',
      items: ['4547315579594', '4547315579648'],
    },
  ],
};

export const storiesData = [
  {
    id: 1,
    link: 'https://shop.muji.tw/muji-journal/pdf/',
    img: 'story01.jpg',
    text: '穿搭型錄',
  },
  {
    id: 2,
    link: 'https://shop.muji.tw/sb/style/?sort=time&coordinate_genre_code=001006',
    img: 'story02.jpg',
    text: 'Stying Advisor 穿搭圖輯',
  },
  {
    id: 3,
    link: 'https://shop.muji.tw/muji-journal/styling_advisor/',
    img: 'story03.jpg',
    text: '服飾搭配諮詢服務',
  },
];
